
export default {
    productData: {
        serialNumber: 'DA-HMS-009',
        name: 'Holzbalkendecke mit Schalldämmplatten l Aufbau 9',
        construction: {
        composition: [
            {
            type: 'screed',
            title: { de: 'Estrich' },
            output: 'ohne',
            value: 'nw-0'
            },
            {
            type: 'soundInsulation',
            title: { de: 'Schalldämmplatte' },
            output: '2 x 12,5 mm',
            value: 'si-25'
            },
            {
            type: 'insulation',
            title: { de: 'Holzfaserdämmplatte' },
            output: '≥ 20',
            value: 'w-20'
            },
            {
            type: 'fill',
            title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 132 kg/m<sup>2</sup>), Rieselschutz' },
            output: '≥ 80',
            value: 'scsb-80'
            },
            {
            type: 'woodenPanel',
            title: { de: 'Holzwerkstoffplatte HW' },
            output: '≥ 22',
            value: 22
            },
            {
            type: 'supportingStructure',
            title: { de: 'Balken' },
            output: '240',
            value: 'b-240'
            },
            {
                type: 'suspendedCeiling',
                title: { de: 'Hohlraumdämpfung' },
                output: '2 x 120',
                value: 'h-240'
              },
            {
            type: 'suspendedCeiling',
            title: { de: 'Federschiene' },
            output: '25',
            value: 'f-25'
            },
            {
                type: 'soundInsulation',
                title: { de: 'Schalldämmplatte' },
                output: '12,5',
                value: 'g-12.5'
              },
              {
                type: 'suspendedCeiling',
                title: { de: 'Gipsplatte GKFI' },
                output: '12,5',
                value: 'g-12.5'
              }
        ],
        sum: {
            output: '437', value: 437
        }
        },
        technicalValues: {
        impactSoundLevel: { // L,nw
            output: '34 (2; 10)',
            value: 34
        },
        soundReductionIndex: { // Rw
            output: '83 (-3; -9)',
            value: 83
        },
        heatTransferCoefficient: { // U-Wert
            output: '0,18',
            value: 0.18
        },
        fireResistance: {
          output: '-', value: null
        },
        massPerUnitArea: {
          output: '249,8 [kg/m²]'
        }
        }
    },
    image: 'da-hms-009.png',
    pdf: 'Holzbalkendecke-mit-Schalldämmplatten-Aufbau-9-DA-HMS-009-Rev01.pdf'
    }
  
